package com.nonopn.skywatcher.common.app.pages.map.view.left

import com.nonopn.skywatcher.app.utils.safeLaunch
import com.nonopn.skywatcher.design.res.Res
import com.nonopn.skywatcher.design.res.april
import com.nonopn.skywatcher.design.res.august
import com.nonopn.skywatcher.design.res.day_of_week0
import com.nonopn.skywatcher.design.res.day_of_week1
import com.nonopn.skywatcher.design.res.day_of_week2
import com.nonopn.skywatcher.design.res.day_of_week3
import com.nonopn.skywatcher.design.res.day_of_week4
import com.nonopn.skywatcher.design.res.day_of_week5
import com.nonopn.skywatcher.design.res.day_of_week6
import com.nonopn.skywatcher.design.res.december
import com.nonopn.skywatcher.design.res.february
import com.nonopn.skywatcher.design.res.january
import com.nonopn.skywatcher.design.res.july
import com.nonopn.skywatcher.design.res.june
import com.nonopn.skywatcher.design.res.march
import com.nonopn.skywatcher.design.res.may
import com.nonopn.skywatcher.design.res.november
import com.nonopn.skywatcher.design.res.october
import com.nonopn.skywatcher.design.res.september
import eu.codlab.viewmodel.StateHandler
import eu.codlab.viewmodel.StateViewModel
import korlibs.time.DateFormat
import korlibs.time.DateTime
import korlibs.time.DateTimeTz
import korlibs.time.DayOfWeek
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import org.jetbrains.compose.resources.StringResource
import kotlin.time.Duration.Companion.milliseconds
import kotlin.time.Duration.Companion.seconds

data class DateSectionModelState(
    val current: DateTime,
    val dateTranslation: DateTranslation,
    val hours: String
)

class DateSectionModel() : StateViewModel<DateSectionModelState>(
    DateSectionModelState(
        current = DateTime.now(),
        dateTranslation = DateTime.nowLocal().toDateTranslation(),
        hours = ""
    )
), StateHandler<DateSectionModelState> {
    init {
        safeLaunch {
            while (isActive) {
                val localDate = DateTime.nowLocal()

                updateState {
                    copy(
                        dateTranslation = localDate.toDateTranslation(),
                    )
                }

                delay(10.seconds)
            }
        }

        safeLaunch {
            while (isActive) {
                val localDate = DateTime.nowLocal()

                updateState {
                    copy(
                        hours = localDate.format(DateFormat("HH:mm:ss"))
                    )
                }

                delay(400.milliseconds)
            }
        }
    }
}

fun DateTimeTz.toDateTranslation() = DateTranslation(
    weekDay = days[dayOfWeek]!!,
    month = months[month.index0],
    day = format("dd").toInt(),
    year = yearInt
)

private val months = listOf(
    Res.string.january,
    Res.string.february,
    Res.string.march,
    Res.string.april,
    Res.string.may,
    Res.string.june,
    Res.string.july,
    Res.string.august,
    Res.string.september,
    Res.string.october,
    Res.string.november,
    Res.string.december,
)

private val days = mapOf(
    DayOfWeek.Sunday to Res.string.day_of_week6,
    DayOfWeek.Monday to Res.string.day_of_week0,
    DayOfWeek.Tuesday to Res.string.day_of_week1,
    DayOfWeek.Wednesday to Res.string.day_of_week2,
    DayOfWeek.Thursday to Res.string.day_of_week3,
    DayOfWeek.Friday to Res.string.day_of_week4,
    DayOfWeek.Saturday to Res.string.day_of_week5,
)

data class DateTranslation(
    val weekDay: StringResource,
    val month: StringResource,
    val day: Int,
    val year: Int
)